import classNames from "classnames";
import React, { useMemo } from "react";
import { Form, InputGroup } from "react-bootstrap";

import { NumericFormat } from "react-number-format";
import { CountryWithCode } from "../../config/filingConstants";
import { useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";
import { UtilService } from "../../services";
import SelectInputField from "./SelectInputField";

type Props = {
  name: string;
  countryCodeName: string;
  value: string;
  countryCodeValue?: string;
  onBlur: any;
  countryCodeOnBlur: any;
  onChange: (value: any) => void;
  onChangeCountryCode: (value?: any) => void;
  isInvalid: boolean | undefined;
  countyCodeIsInvalid: boolean | undefined;
  errorMsg?: string | undefined;
  countryCodeErrorMsg?: string | undefined;
  size?: "lg" | "sm" | undefined;
  placeholder?: string;
  decimalUpto?: number;
  classes?: any;
  isDisabled?: boolean;
  label?: string;
  maxLength?: number;
  groupStyle?: "lakh" | "thousand";
  note?: string;
  allowNegative?: boolean;
  groupTextClass?: string;
  formType?: "ITR" | "GENERAL";
};

const CodePhoneInputField: React.FC<Props> = (props: Props) => {
  const {
    name,
    countryCodeName,
    value,
    countryCodeValue,
    onBlur,
    countryCodeOnBlur,
    onChange,
    onChangeCountryCode,
    isInvalid,
    countyCodeIsInvalid,
    errorMsg,
    countryCodeErrorMsg,
    size,
    placeholder = "",
    decimalUpto = 0,
    classes,
    isDisabled = false,
    label = "",
    maxLength,
    groupStyle = "lakh",
    // allowNegative = false,
    formType = "ITR"
  } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const isFieldDisabled = useMemo(() => {
    if (formType === "GENERAL") {
      if (isDisabled) {
        return isDisabled;
      }
      return false;
    }
    if (isFilingReadOnly) {
      return true;
    }
    return isDisabled;
  }, [isDisabled, isFilingReadOnly, formType]);

  return (
    <Form.Group className="form-group" controlId={name}>
      {label ? <Form.Label className="small-label">{label}</Form.Label> : null}
      <InputGroup className={classNames("input-group-phone", isFieldDisabled && "is-disabled")}>
        <InputGroup.Text className={classNames("prepend-text", isInvalid && "border-danger")}>
          <SelectInputField
            name={countryCodeName}
            menuMinWidth="220px"
            menuZIndex={9}
            isSearchable={true}
            options={UtilService.convertToCountryCode(CountryWithCode)}
            value={{
              "label": countryCodeValue,
              "value": countryCodeValue
            }}
            onChange={onChangeCountryCode}
            onBlur={countryCodeOnBlur}
            isInvalid={countyCodeIsInvalid}
            errorMsg={countryCodeErrorMsg}
            containerClasses={"input-group-select w-100"}
          />
        </InputGroup.Text>
        <NumericFormat
          className={classNames(
            "form-control",
            size === "lg" && "form-control-lg",
            size === "sm" && "form-control-sm",
            classes,
            isInvalid && "border-danger"
          )}
          disabled={isFieldDisabled}
          name={name}
          value={value}
          onBlur={onBlur}
          autoComplete="false"
          placeholder={placeholder}
          maxLength={maxLength}
          onValueChange={(values) => {
            const { value } = values;
            onChange(value);
          }}
          allowLeadingZeros={false}
          decimalScale={decimalUpto}
          thousandsGroupStyle={groupStyle}
        />
      </InputGroup>
      {isInvalid && errorMsg ? <div className="field-error">{errorMsg}</div> : null}
    </Form.Group>
  );
};

export default CodePhoneInputField;
